export const reactPdf = {
  '.pdf-document-viewer': {
    height: '100%',
  },
  '.pdf-document-viewer .react-pdf__message': {
    height: '100%',
  },
};
